import { render, staticRenderFns } from "./select_object.vue?vue&type=template&id=318ee4ad&scoped=true&"
import script from "./select_object.vue?vue&type=script&lang=ts&"
export * from "./select_object.vue?vue&type=script&lang=ts&"
import style0 from "./select_object.vue?vue&type=style&index=0&id=318ee4ad&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318ee4ad",
  null
  
)

export default component.exports